import { Utilities } from 'src/app/services/utilities';
import { AbstractControl, Validators } from '@angular/forms';
import { BaseVariableControl } from './_base-control';



export class ButtonGroupControl extends BaseVariableControl {

    get keyField() {
        const templateData = this.variable.displayMetadata.templateData;
        const firstItem = (templateData.list || templateData.List)[0];
        return Utilities.getVariableCaseInsensitive(firstItem, templateData.keyField || templateData.KeyField);
    }

    get displayField() {
        const templateData = this.variable.displayMetadata.templateData;
        const firstItem = (templateData.list || templateData.List)[0];
        return Utilities.getVariableCaseInsensitive(firstItem, templateData.displayField || templateData.DisplayField);
    }

    buildInitialFormControlValue() {
        const metadata = this.variable.displayMetadata;
        if (metadata.templateData) {
            return this.variable.value != null ? ((metadata.templateData.list || metadata.templateData.List) as any[]).find(item => item[this.keyField] === this.variable.value) || this.variable.value : null;
        }

        return this.variable.value;
    }

    createReactiveControl(setValueChangedEvent: boolean = true) {

        // format fields
        this.formatTemplateData();

        this.addFormControl();

        this.setValidators(this.form.controls[this.variable.name]);

		if (setValueChangedEvent) {
            this.setOnChangeEvent(this.form.controls[this.variable.name]);
            this.variable.value = this.getVariableValue();
        }
    }

    formatTemplateData() {
        const templateData = this.variable.displayMetadata && this.variable.displayMetadata.templateData;
        if (!Object.getOwnPropertyNames(templateData).find(prop => prop === 'keyField')) {
            templateData.keyField = templateData.KeyField;
            templateData.displayField = templateData.DisplayField;
            templateData.list = templateData.List;
            if (templateData.list.length > 0) {
                (templateData.list as any[]).forEach(item => {
                    item[Utilities.camelize(templateData.keyField)] = item[templateData.KeyField];
                    item[Utilities.camelize(templateData.displayField)] = item[templateData.DisplayField];
                });
            }
        }
    }

    getDisplayValueForGrid(item: any): any {
        const variableName = Utilities.getVariableCaseInsensitive(item, this.variable.name);
        const value = item[variableName];
        const templateData = this.variable.displayMetadata.templateData;

        if (value == null) {
            return null;
        } else {
            let itemValue = null;
            if (value[this.displayField]) {
                itemValue = value[this.displayField];
            }

            if (itemValue == null) {
                return ((templateData.list || templateData.List) as any[]).find(listItem => listItem[this.keyField] === value)[this.displayField];
            } else {
                return itemValue;
            }
        }
    }

    getValue(item: any): any {
        if (item) {
            const wrapperValue = item[Utilities.getVariableCaseInsensitive(item, this.variable.name)];
            const variableName = Utilities.getVariableCaseInsensitive(item, this.variable.name);
            const propertyName = Utilities.getVariableCaseInsensitive(item[variableName], this.variable.displayMetadata.templateData.keyField);

            let result = wrapperValue;
            if (wrapperValue && propertyName) {
                result = wrapperValue[propertyName];
            }

            return result;
        } else {
            const result = this.formControl.value;
            return result != null ? result[this.keyField] : result;
        }
    }

    getDisplayValue(item: any): any {
        const tempData = this.variable.displayMetadata.templateData;
        if (tempData && tempData.keyField) {
            let tempValue = null;
            if (item) {
                const wrapperValue = item[Utilities.getVariableCaseInsensitive(item, this.variable.name)];
                const variableName = Utilities.getVariableCaseInsensitive(item, this.variable.name);
                const propertyName = Utilities.getVariableCaseInsensitive(item[variableName], this.variable.displayMetadata.templateData.keyField);

                tempValue = wrapperValue;
                if (wrapperValue && propertyName) {
                    tempValue = wrapperValue[propertyName];
                }

            } else {
                tempValue = this.variable.value;

            }

            if (tempValue != null) {

                const keyField = this.variable.displayMetadata.templateData.keyField;
                const matchItem = this.variable.displayMetadata.templateData.list.find(listItem => listItem[Utilities.getVariableCaseInsensitive(listItem, keyField)] === tempValue);
                if (matchItem) {
                    const displayField = this.variable.displayMetadata.templateData.displayField;
                    return matchItem[Utilities.getVariableCaseInsensitive(matchItem, displayField)];
                }

            }

            return 'N/A';
        } else {
            return tempData;
        }
    }

    setValidators(formControl: AbstractControl) {

        const validators = this.variable.displayMetadata.templateData.validators?.map(element => {

            let type = <string> element.typeId;
            if (type.includes("RequiredAttribute"))
            {
                return Validators.required;
            }
        });

        formControl.setValidators(Validators.compose(validators));
    }
}
